import { Box } from '@zillow/constellation-10';
import { MessageListSkeleton } from '../MessageList/skeleton';
import { ConversationListSkeleton } from '../ConversationList/skeleton';
import { default as RenterProfileSkeleton } from '../InboxSidebar/skeleton';
import { default as ConversationNavSkeleton } from '../ConversationNav/skeleton';
import {
  columnWrapperStyles,
  inboxAppLayoutContainerStyles,
  inboxMainContentStyles,
  inboxPageRootStyles,
  pageContentStyles,
  primaryColumnStyles,
  tertiaryColumnStyles,
} from '../../styles/inboxPageStyles';
import SecondaryColumn from '../SecondaryColumn';
import Layout from '../Layout';
import InboxHeaderSkeleton from '../InboxHeader/skeleton';
import { ConversationSearchBarSkeleton } from '../SearchBar/Skeleton';

export default function InboxPageSkeleton() {
  return (
    <Layout
      showFooter={false}
      mainContentStyles={inboxMainContentStyles}
      pageRootStyles={inboxPageRootStyles}
      appLayoutContainerStyles={inboxAppLayoutContainerStyles}
    >
      <Box css={pageContentStyles}>
        <InboxHeaderSkeleton />

        <Box css={columnWrapperStyles}>
          <Box
            css={{
              ...primaryColumnStyles,
              display: 'flex',
            }}
          >
            <ConversationSearchBarSkeleton />
            <ConversationListSkeleton />
          </Box>

          <SecondaryColumn shouldHideOnMobile={true}>
            <ConversationNavSkeleton />
            <MessageListSkeleton />
          </SecondaryColumn>

          <Box
            css={{
              ...tertiaryColumnStyles,
              display: { base: 'none', xxl: 'flex' },
            }}
          >
            <RenterProfileSkeleton />
          </Box>
        </Box>
      </Box>
    </Layout>
  );
}
